module.exports = __webpack_public_path__ + "static/media/aura.876902e7.jpeg";